import { Injectable } from '@angular/core';
import { CONFIGURATION } from "../app.config";
import { Observable } from "rxjs/Observable";
import { Http, Response, Headers, RequestOptions } from "@angular/http";

@Injectable()
export class ResetpasswordService {

  private _LoginUrl = CONFIGURATION.baseAuthURL;


  constructor(private _http: Http) { }

  resetPassword(newvalues: any): Observable<any> {
    const headers = new Headers();
    const options = new RequestOptions({ headers: headers });
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    headers.append('Content-Type', 'application/json');
    headers.append('email', newvalues.username);
    return this._http.post(this._LoginUrl + '/reset-password', newvalues, { headers: headers })
    .map((res: Response) => res.json())
      .catch(this.handleError);
  }

  private handleError(error: Response) {
    // in a real world app, we may send the server to some remote logging infrastructure
    // instead of just logging it to the console
    console.error(error);
    return Observable.throw(error.json().error || 'Failed in web api(Server error) ');
  }
}



// WEBPACK FOOTER //
// ./src/app/resetpassword/resetpassword.service.ts